import React, { Component, Fragment } from 'react';
import Validator, { Validation, Message } from 'es-validator';
import { withStyles, Tabs, Tab, FormControlLabel, Checkbox } from '@material-ui/core';
import { connect } from 'react-redux';
import Terms from './Terms';
import './index.css';

import PropTypes from 'prop-types';
import * as actions from 'actions';
import * as types from 'actions/ActionTypes';
import { Row, Col, Card, Button } from 'antd';
import { notification } from 'components/utils';

const styles = theme => ({
	root: {
		color: '#FFFFFF',
		fontSize: 13,
	},
	label: {
		fontSize: '1em',
		color: 'rgba(66, 66, 66, .7)!important',
	},
	tabsRoot: {},
	tabsIndicator: {
		backgroundColor: '#FFFFFF',
	},
	tabRoot: {
		textTransform: 'initial',
		minWidth: 62,
		fontWeight: 500,
		fontSize: 13,
		color: '#FFFFFF',
		marginRight: theme.spacing.unit * 4,
		fontFamily: ['Noto Sans KR', 'sans-serif'].join(','),
		'&:hover': {
			color: '#FFFFFF',
			opacity: 1,
		},
		'&$tabSelected': {
			color: '#FFFFFF',
			fontWeight: 800,
		},
		'&:focus': {
			color: '#FFFFFF',
		},
	},
	tabSelected: {},
});

let mapStateToProps = state => {
	return {
		authenticated: state.auth.authenticated,
		registered: state.auth.registered,
		user: state.auth.user,
	};
};

const mapDispatchToProps = dispatch => ({
	login: user => dispatch(actions.loginLocal(user)),
	validate: user => dispatch(actions.validate(user)),
	logout: () => dispatch(actions.logout()),
	join: user => dispatch(actions.join(user)),
	find: user => dispatch(actions.find(user)),
	register: registered => dispatch(actions.setRegistered(registered)),
	snsLogin: snsInfo => dispatch(actions.snsLogin(snsInfo)),
});

let childWindow;

class Login extends Component {
	_isMounted = false;

	constructor(props) {
		super(props);

		//const parsedSearch = queryString.parse(props.location.search);

		this.errorPrint = v => (
			<div key={v.key} className="valid-feedback">
				<span>{v.message}</span>
			</div>
		);

		this.validatorForLogin = new Validator({
			email: {
				_name: '이메일',
				_hasText: { message: '이메일을 입력해 주세요.' },
				_email: { message: '이메일 형식이 올바르지 않습니다.' },
				_minLength: {
					min: 5,
					message: '이메일 형식이 올바르지 않습니다.',
				},
			},
			password: {
				_name: '암호',
				_hasText: { message: '비밀번호를 입력해주세요.' },
			},
		});

		this.validatorForJoin = new Validator({
			name: {
				_name: '이름',
				_hasText: { message: '이름을 입력해 주세요.' },
			},
			/*
			phone: {
				_name: '전화번호',
				_hasText: { message: '휴대 전화번호를 입력해 주세요.' },
				_int: { message: '숫자 이외의 글자는 입력이 불가합니다.' },
				_minLength: {
					min: 10,
					message: '전화번호 형식이 올바르지 않습니다.',
				},
			},
			*/
			joinEmail: {
				_name: '이메일',
				_hasText: { message: '이메일을 입력해 주세요.' },
				_email: { message: '이메일 형식이 올바르지 않습니다.' },
				_minLength: {
					min: 5,
					message: '이메일 형식이 올바르지 않습니다.',
				},
			},
			password1: {
				_name: '암호',
				_hasText: { message: '비밀번호를 입력해주세요.' },
				_minLength: {
					min: 8,
					message: '8자 이상의 비밀번호를 입력해 주세요.',
				},
				_makeFunc: {
					func: value => {
						var regExp = /[~!@#$%^&*()_+|<>?:{}]/;
						return regExp.test(value);
					},
					message: '한개 이상의 특수문자를 넣어서 비밀번호를 생성해 주세요.',
				},
			},
			password2: {
				_name: '암호확인',
				_hasText: { message: '비밀번호를 입력해주세요.' },
				_makeFunc: {
					func: (value, state) => value === state.password1,
					message: '암호가 일치하지 않습니다.',
				},
			},
			checkedTerms: {
				_name: '약관',
				_checked: { message: '약관을 꼭 확인하시고 동의해 주세요.' },
			},
		});

		this.validatorForFind = new Validator({
			findEmail: {
				_name: '이메일',
				_hasText: { message: '이메일을 입력해 주세요.' },
				_email: { message: '이메일 형식이 올바르지 않습니다.' },
				_minLength: {
					min: 5,
					message: '이메일 형식이 올바르지 않습니다.',
				},
			},
		});

		const login = {
			email: '',
			password: '',
		};

		const join = {
			name: '',
			//phone: '',
			joinEmail: '',
			password1: '',
			password2: '',
			checkedTerms: false,
		};

		const find = {
			findEmail: '',
		};

		this.state = {
			...login,
			...join,
			...find,
			vLogin: this.validatorForLogin.prepare(login),
			vJoin: this.validatorForJoin.prepare(join),
			vFind: this.validatorForFind.prepare(find),
			path: '/',
			hash: '#0',
			open: false,
			value: props.value,
			redirectUrl: '/',
			snsLoginInfo: '/',
			isAuth: false,
		};

		window.addEventListener('message', this.receiveMessage, false);
	}

	fetchSnsLoginInfo = async snsInfo => {
		//console.log('snsInfo: ' + snsInfo);
		this.props.snsLogin(snsInfo);
	};

	receiveMessage = event => {
		const snsLoginInfo = event.data;
		if (
			snsLoginInfo !== undefined &&
			snsLoginInfo !== null &&
			snsLoginInfo.error !== undefined &&
			snsLoginInfo.error !== null
		) {
			this.checkLoginError(snsLoginInfo);
		}

		if (
			snsLoginInfo !== undefined &&
			snsLoginInfo !== null &&
			snsLoginInfo.token !== undefined &&
			snsLoginInfo.token !== null
		) {
			this.fetchSnsLoginInfo(snsLoginInfo);
		}

		if (childWindow != null) {
			childWindow.close();
		}
		/*

		event.origin is sender domain 

		event.source is window.opener

		*/
	};

	componentDidMount() {
		//console.log();
		this._isMounted = true;

		const snsLoginInfo = this.state.snsLoginInfo;
		if (
			snsLoginInfo !== undefined &&
			snsLoginInfo !== null &&
			snsLoginInfo.error !== undefined &&
			snsLoginInfo.error !== null
		) {
			this.checkLoginError(snsLoginInfo);
		}

		this.setState({
			authenticated: this.props.authenticated,
			registered: this.props.registered,
			user: this.props.user,
		});
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			authenticated: nextProps.authenticated,
			registered: nextProps.registered,
			user: nextProps.user,
			value: nextProps.value,
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.authenticated !== prevState.authenticated) {
			this.setState({ isAuth: this.state.authenticated });
		}
		if (this.state.registered !== prevState.registered) {
			if (this.state.registered) {
				this.props.register(false);
				//	return <Redirect to={path} />;
				this.setState({ value: 0 });
			}
		}
	}

	checkLoginError(snsLoginInfo) {
		let target = '';
		let message = '';

		switch (snsLoginInfo.type) {
			case 'F':
				target = 'Facebook';
				break;
			case 'G':
				target = 'Google';
				break;
			case 'N':
				target = 'Naver';
				break;
			case 'K':
				target = 'Kakao';
				break;
			default:
				break;
		}

		switch (snsLoginInfo.error) {
			case 'L0000000001':
				message = '의 사용자 정보 확인 중에 오류가 발생하였습니다. 다시 시도해 주세요.';
				break;
			case 'L0000000002':
				message = '의 이메일로 이미 등록된 정보가 존재합니다. 확인 후 다시 로그인 해 주세요.';
				break;
			default:
				break;
		}

		notification.openNotificationWithIcon('error', target + message, null);
	}

	onSubmit = (e, gubn) => {
		e.preventDefault();
		const { vLogin, vJoin, vFind, ...state } = this.state;
		const { login, join, find } = this.props;

		switch (gubn) {
			case 'login':
				this.setState({
					vLogin: this.validatorForLogin.submit(state),
				});

				if (!this.validatorForLogin.getError()) {
					login({ email: this.state.email, password: this.state.password });
				}
				break;
			case 'join':
				this.setState({
					vJoin: this.validatorForJoin.submit(state),
				});

				if (!this.validatorForJoin.getError()) {
					join({
						name: this.state.name,
						//phone: this.state.phone,
						email: this.state.joinEmail,
						password: this.state.password1,
					});
				}
				break;
			case 'find':
				this.setState({
					vFind: this.validatorForFind.submit(state),
				});

				if (!this.validatorForFind.getError()) {
					find({ email: this.state.findEmail });
				}
				break;
			default:
				break;
		}
	};

	/*
	onLoginWithSocial = gubn => (e) => {
		e.preventDefault();

		switch (gubn) {
			case 'facebook':
				this.props.loginFacebook();
				break;
			case 'kakao':
				this.props.loginKakao();
				break;
			case 'naver':
				this.props.loginKakao();
				break;
			case 'google':
				this.props.loginKakao();
				break;
			default:
				break;
		}
	};
	*/

	handleChange = name => event => {
		//console.log(event.target.checked);
		this.setState({ [name]: event.target.checked });
	};

	handleChangeTabs = (event, value) => {
		this.setState({ value });
	};

	handleClickOpen = () => {
		this.setState({
			open: true,
		});
	};

	handleClickToFindPassword = () => {
		this.setState({
			value: 2,
		});
	};

	handleClose = () => {
		this.setState({
			open: false,
		});
	};

	onInputTextChange = input => e => {
		this.setState({
			[input]: e.target.value,
		});
	};

	setShowPage = pageType => {
		return pageType === '#ms-register-tab' ? 1 : 0;
	};

	onLogout = e => {
		e.preventDefault();
		this.props.logout();
	};

	snsOpen = (e, url, size) => {
		e.preventDefault();
		childWindow = window.open(
			types.LOCAL_API_URL + url,
			'PopupWin',
			'width=' + size.width + ',height=' + size.height
		);

		if (childWindow == null) {
			notification.openNotificationWithIcon(
				'info',
				'팝업이 차단 되어 있습니다. 팝업을 허용 후 이용해 주세요.',
				null
			);
		}
	};

	render() {
		const { vLogin, vJoin, vFind, value, user } = this.state;
		const { email, password } = vLogin;
		const { name, joinEmail, password1, password2, checkedTerms } = vJoin;
		const { findEmail } = vFind;

		return (
			<Fragment>
				<div style={{ height: '100%' }}>
					<Row type="flex" justify="center" align="middle" style={{ height: '100%' }}>
						<Col>
							<div className="form-holder" style={{ minHeight: 500 }}>
								<div className="form-content">
									<div className="form-items">
										<div className="website-logo-inside">
											<div className="logo">
												<img className="" src="/assets/img/logo/Logo_40_CW.png" alt="Home" />
											</div>
										</div>
										{this.state.isAuth && (
											<Fragment>
												<Card title={'로그인 되셨습니다.'} bodyStyle={{ padding: 10 }}>
													<Row type="flex" justify="center">
														<Col>{user && user.userName + '님 환영합니다.'}</Col>
													</Row>
													<Row type="flex" justify="center" style={{ marginTop: 10 }}>
														<Col>
															<Button type="primary" onClick={this.onLogout}>
																로그아웃
															</Button>
														</Col>
													</Row>
												</Card>
											</Fragment>
										)}
										{!this.state.isAuth && (
											<Fragment>
												<Tabs
													value={value}
													onChange={this.handleChangeTabs}
													classes={{
														root: this.props.classes.tabsRoot,
														indicator: this.props.classes.tabsIndicator,
													}}
													style={{ marginBottom: 20 }}
												>
													<Tab
														disableRipple
														classes={{
															root: this.props.classes.tabRoot,
															selected: this.props.classes.tabSelected,
														}}
														label="들어가기"
													/>
													<Tab
														disableRipple
														classes={{
															root: this.props.classes.tabRoot,
															selected: this.props.classes.tabSelected,
														}}
														label="가입하기"
													/>
													<Tab
														disableRipple
														classes={{
															root: this.props.classes.tabRoot,
															selected: this.props.classes.tabSelected,
														}}
														label="알아보기"
													/>
												</Tabs>
												<form>
													{value === 0 && (
														<Fragment>
															<Validation isValid={email.error}>
																<input
																	className="form-control"
																	type="text"
																	name="email"
																	placeholder="이메일 주소"
																	autoComplete="username"
																	onChange={this.onInputTextChange('email')}
																	value={this.state.email}
																/>
																<Message once valid={email} render={this.errorPrint} />
															</Validation>
															<Validation isValid={password.error}>
																<input
																	className="form-control"
																	type="password"
																	name="password"
																	placeholder="비밀번호"
																	autoComplete="new-password"
																	onChange={this.onInputTextChange('password')}
																	value={this.state.password}
																/>
																<Message
																	once
																	valid={password}
																	render={this.errorPrint}
																/>
															</Validation>
															<div className="form-button">
																<button
																	className="ibtn ml-3"
																	onClick={e => this.onSubmit(e, 'login')}
																>
																	들어가기
																</button>
															</div>
															<div>
																<span
																	className="link-text-reset-password"
																	onClick={this.handleClickToFindPassword}
																>
																	비밀번호를 잊어버리셨나요? &nbsp;&nbsp;
																</span>
															</div>
														</Fragment>
													)}
													{value === 1 && (
														<Fragment>
															<Validation isValid={name.error}>
																<input
																	className="form-control"
																	type="text"
																	name="name"
																	placeholder="이름"
																	onChange={this.onInputTextChange('name')}
																	value={this.state.name}
																/>
																<Message once valid={name} render={this.errorPrint} />
															</Validation>
															{/*}
										<div className="flex">
											<Validation isValid={phone.error}>
												<input
													className="form-control"
													type="text"
													name="phone"
													placeholder="휴대 전화번호 ('-' 제외)"
													onChange={this.onInputTextChange('phone')}
													value={this.state.phone}
												/>
												<Message once valid={phone} render={this.errorPrint} />
											</Validation>
											<div className="certify-button">
												<button id="certify" type="submit" className="ibtn">
													인증
												</button>
											</div>
										</div>
										*/}

															<Validation isValid={joinEmail.error}>
																<input
																	className="form-control"
																	type="email"
																	name="joinEmail"
																	placeholder="이메일 주소"
																	onChange={this.onInputTextChange('joinEmail')}
																	value={this.state.joinEmail}
																/>
																<Message
																	once
																	valid={joinEmail}
																	render={this.errorPrint}
																/>
															</Validation>

															<Validation isValid={password1.error}>
																<input
																	className="form-control"
																	type="password"
																	name="password1"
																	placeholder="비밀번호 (특수문자포함 8자이상)"
																	autoComplete="new-password"
																	onChange={this.onInputTextChange('password1')}
																	value={this.state.password1}
																/>
																<Message
																	once
																	valid={password1}
																	render={this.errorPrint}
																/>
															</Validation>
															<Validation isValid={password2.error}>
																<input
																	className="form-control"
																	type="password"
																	name="password2"
																	placeholder="비밀번호 확인"
																	autoComplete="new-password"
																	onChange={this.onInputTextChange('password2')}
																	value={this.state.password2}
																/>
																<Message
																	once
																	valid={password2}
																	render={this.errorPrint}
																/>
															</Validation>
															<div className="flex">
																<div className="terms-box">
																	<span
																		className="terms-link"
																		onClick={this.handleClickOpen}
																	>
																		약관보기
																	</span>
																</div>
																<Validation isValid={checkedTerms.error}>
																	<FormControlLabel
																		control={
																			<Checkbox
																				checked={this.state.checkedTerms}
																				onChange={this.handleChange(
																					'checkedTerms'
																				)}
																				value="checkedTerms"
																				classes={{
																					root: this.props.classes.root,
																				}}
																			/>
																		}
																		label="약관을 모두 확인하였으며, 동의합니다."
																		classes={{
																			label: this.props.classes.root,
																		}}
																	/>
																	<Message
																		once
																		valid={checkedTerms}
																		render={this.errorPrint}
																	/>
																</Validation>
															</div>
															<div className="form-button">
																<button
																	className="ibtn"
																	onClick={e => this.onSubmit(e, 'join')}
																>
																	가입하기
																</button>
															</div>
														</Fragment>
													)}
													{value === 2 && (
														<Fragment>
															<Validation isValid={findEmail.error}>
																<input
																	className="form-control"
																	type="text"
																	name="findname"
																	placeholder="이메일 주소"
																	onChange={this.onInputTextChange('findEmail')}
																	value={this.state.findEmail}
																/>
																<Message
																	once
																	valid={findEmail}
																	render={this.errorPrint}
																/>
															</Validation>
															<div className="form-button full-width">
																<button
																	className="ibtn btn-forget"
																	onClick={e => this.onSubmit(e, 'find')}
																>
																	이메일로 비밀번호 재설정
																</button>
															</div>
														</Fragment>
													)}
												</form>
												<div className="other-links">
													<span>또 다른 들어가는 방법</span>
													<a
														href="#0"
														className="sns-link"
														onClick={e =>
															this.snsOpen(e, '/auth/facebook', {
																width: 800,
																height: 800,
															})
														}
													>
														<img src="/assets/img/icon/facebook.png" alt="Facebook" />
													</a>
													<a
														href="#0"
														className="sns-link"
														onClick={e =>
															this.snsOpen(e, '/auth/google', {
																width: 800,
																height: 800,
															})
														}
													>
														<img src="/assets/img/icon/google.png" alt="Google" />
													</a>
													<a
														href="#0"
														className="sns-link"
														onClick={e =>
															this.snsOpen(e, '/auth/naver', {
																width: 800,
																height: 800,
															})
														}
													>
														<img src="/assets/img/icon/naver.png" alt="Naver" />
													</a>
													<a
														href="#0"
														className="sns-link"
														onClick={e =>
															this.snsOpen(e, '/auth/kakao', {
																width: 500,
																height: 500,
															})
														}
													>
														<img src="/assets/img/icon/kakaotalk.png" alt="Kakao" />
													</a>
												</div>
											</Fragment>
										)}
									</div>
								</div>
							</div>
						</Col>
					</Row>
				</div>
				<Terms isOpen={this.state.open} handleClose={this.handleClose} />
			</Fragment>
		);
	}
}

Login.propTypes = {
	classes: PropTypes.object.isRequired,
	authenticated: PropTypes.bool,
	registered: PropTypes.bool,
};

Login.defaultProps = {
	classes: false,
	authenticated: false,
	registered: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Login));
